import Axios from 'axios';

const axios = Axios.create({
    baseURL: process.env.VUE_APP_API_URL_BASE,
});

import firebase from 'firebase/app';
import 'firebase/auth';
import router from '@/router';
import FieldValue = firebase.firestore.FieldValue;
import Timestamp = firebase.firestore.Timestamp;

export function getToken(): Promise<string> {
    const user = firebase.auth().currentUser;
    if (user != null) {
        return user.getIdToken();
    } else {
        return new Promise((resolve, reject) => reject('user not found'));
    }
}

export default {
    rakuten: {
        search(page: number, perPage: number, title: string | null, author: string | null,
               publisherName: string | null, isbn: string | null, sort: string | null) {
            const p: { [key: string]: any; } = {};
            p.applicationId = appID;
            p.affiliateId = affiliateId;
            if (title != null) {
                p.title = title;
            }
            if (author != null) {
                p.author = author;
            }
            if (publisherName != null) {
                p.publisherName = publisherName;
            }
            if (isbn != null) {
                p.isbn = isbn;
            }
            if (sort != null) {
                p.sort = sort;
            }
            p.page = page;
            p.hits = perPage;

            return Axios.get<SearchResult>(
                `${rakutenBaseURL}`,
                {
                    headers: {'Content-Type': 'application/json'},
                    params: p,
                },
            );
        },
    },
};

const rakutenBaseURL = 'https://app.rakuten.co.jp/services/api/BooksBook/Search/20170404';
const appID = '1035362638897131844';
const affiliateId = '188fe732.33eb93bf.188fe733.aaced19b';

export interface ContentResult<T> {
    status: number;
    content: T;
}

export interface MultiContentResult<T> {
    status: number;
    content: T[];
}

export interface SearchResult {
    Items: Contents[];
    page: number;
    pageCount: number;
}

export interface Contents {
    Item: Content;
}

export interface Content {
    isbn: string;
    title: string;
    author: string;
    smallImageUrl: string;
    mediumImageUrl: string;
    largeImageUrl: string;
    publisherName: string;
    itemPrice: string;
    itemUrl: string;
    affiliateUrl: string;
    itemCaption: string;
}

export interface Impressions {
    id: string;
    image_url: string;
    isbn: string;
    book_title: string;
    book_author: string;
    book_thumb_img: string;
    book_publisher: string;
    book_affiliateUrl: string;
    created_at: Timestamp;
}

// import {captureMessage, Severity} from '@sentry/browser';
export function errorRoute(err: string) {
    // if (process.env.NODE_ENV === 'production') {
    //     captureMessage(err, Severity.Error);
    // }
    router.push({name: 'login'});
}


export function logout() {
    firebase.auth().signOut()
        .then(() => {
            localStorage.clear();
            return router.push({name: 'login'});
        })
        .catch((err) => {
            console.log('sign out error');
        });
}
